export default {"src":"/_next/static/media/storj.3207b68d.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};